import { Gig } from "gql-gen";

import { GigReportStep } from "interfaces/ReportStep";

import type { Data } from "./index";

type NextStep
    = { key: "expenses" }
    | GigReportStep

export function getNextStep(data: Data, stepKey: string, gig: Gig): NextStep | null {
  const currentIndex = data.gigReportSteps.findIndex(rs => rs.key === stepKey);
  const isRegularStep = currentIndex > -1 && currentIndex < data.gigReportSteps.length - 1;

  if (isRegularStep) {
    return data.gigReportSteps[currentIndex + 1];
  }

  const allowExpenses = !!gig.programRole?.allowExpenses;

  if (allowExpenses) {
    return { key: "expenses" };
  }

  return null
}